/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

import { FlowIfDisabled, FlowIfEnabled } from '@/components/blocks/FlexFlow';
import { OneClick } from '@/components/blocks/OneClick';
import { productCardActionButtonProps } from '@/components/blocks/ProductCard/styles/actionButtonProps';
import { productCardInventoryStack } from '@/components/blocks/ProductCard/styles/inventoryStack';
import { useLocalization } from '@/data/Localization';
import { isB2BStore, useSettings } from '@/data/Settings';
import { useUser } from '@/data/User';
import { EMS_STORE_FEATURE } from '@/data/constants/flexFlowStoreFeature';
import { ContentContext } from '@/data/context/content';
import { ProductCardContextValue } from '@/data/types/ProductCard';
import { Stack } from '@mui/material';
import { FC, useContext } from 'react';

export const ProductCardAddToCartWithInventory: FC = () => {
	const { sku, product, onAddToCart, loginStatus } = useContext(
		ContentContext
	) as ProductCardContextValue;
	const nlsProduct = useLocalization('productDetail');
	const { settings } = useSettings();
	const { loading } = useUser();
	const isB2B = isB2BStore(settings);

	const entity = sku ?? product;
	const addToCartText = isB2B ? nlsProduct.addToCurrentOrder.t() : nlsProduct.AddToCart.t();
	const dtId = `product-add-to-cart-${product.partNumber}`;
	const disabled = !product.buyable || !product.productPrice?.offer;
	const quantity = parseFloat(product['x_measurements.nominalQuantity'] ?? '1');

	return (
		<Stack {...productCardInventoryStack}>
			{/* eslint-disable-next-line react/forbid-component-props */}
			<OneClick
				data-testid={dtId}
				id={dtId}
				className="add-to-cart"
				onClick={onAddToCart(entity, quantity)}
				disabled={loading || disabled}
				{...productCardActionButtonProps}
			>
				<FlowIfEnabled feature={EMS_STORE_FEATURE.GUEST_SHOPPING}>{addToCartText}</FlowIfEnabled>
				<FlowIfDisabled feature={EMS_STORE_FEATURE.GUEST_SHOPPING}>
					{loginStatus ? addToCartText : nlsProduct.SignIn.t()}
				</FlowIfDisabled>
			</OneClick>
		</Stack>
	);
};
